export default "__VITE_ASSET__D11r4piv__"